/* Jukebox Fusion - Alexander Galperin and Marcel Joschko */

export const particleConfig = {
    THICKNESS: Math.pow(80, 2),
    SPACING: 4,
    MARGIN: 500,
    COLOR: 240,
    DRAG: 0.995,
    EASE: 0.05,
};
